import "./Leaderboard.css";
import "../globals/global.css";
import NavigationBar from "./../../../components/navbar/NavigationBar";
import PageTitle from "../../../components/Page Title/PageTitle";
import { useNavigate } from "react-router-dom";

const Leaderboard = () => {
  const navigate = useNavigate();

  return (
    <div className="pagebackground">
      <NavigationBar />
      <PageTitle title={"Leaderboards"} />
      <div className="center">
        <div className="pagebox pagebox-leaderboard">
          <p className="sectionSubTitleText">Leaderboard page, like the good ol' days</p>
          <p className="sectionBodyText">
            This is the leaderboards page, similarly to the one from the old website we chose to bring back the different catergorys. as seen below they are: Overall, Tactical, Support, Weapons,
            Vehicles and finally, Assualt teams. each main category has some minor catergories, For example: Overall has kills, headshots and score. each of these minor catergories is a leaderboard in
            and of itself!
            <br />
            <br /> meaning in total we have 30 leaderboards for everyone to try and get onto!
          </p>
          <p onClick={() => navigate("/leaderboard-overall")} className="leaderboardCatergoryText">
            Overall
          </p>
          <p onClick={() => navigate("/leaderboard-tactical")} className="leaderboardCatergoryText">
            Tactical
          </p>
          <p onClick={() => navigate("/leaderboard-support")} className="leaderboardCatergoryText">
            Support
          </p>
          <p onClick={() => navigate("/leaderboard-weapons")} className="leaderboardCatergoryText">
            Weapons
          </p>
          <p onClick={() => navigate("/leaderboard-vehicles")} className="leaderboardCatergoryText">
            Vehicles
          </p>

          <p onClick={() => navigate("/leaderboard-assaultteams")} className="leaderboardCatergoryText">
            Assault Teams
          </p>
        </div>
      </div>
    </div>
  );
};
export default Leaderboard;
